import { createFileRoute, Outlet } from '@tanstack/react-router';
import AdvancedLayout from 'src/components/layout/AdvancedLayout';
import NotFoundContent from 'src/components/layout/NotFoundContent';

export const Route = createFileRoute('/_authenticated/_layout-advanced')({
  component: () => (
    <AdvancedLayout>
      <Outlet />
    </AdvancedLayout>
  ),
  notFoundComponent: () => <NotFoundContent className="mt-2" />,
});
